import { Component, Input, OnInit } from '@angular/core';
import { ReturnIcon } from 'src/app/models/shared/return-icon';
import { IconTypeEnum } from 'src/app/models/shared/icon-type-enum';

// The size conversions that ion-icons use
enum sizeConversionEnum
{
  SMALL = 16,
  LARGE = 32
}

@Component(
{
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})

export class IconComponent implements OnInit
{
  // Inputs
  @Input() icon: ReturnIcon;
  @Input() size: any = "large";
  @Input() color: string = "primary";

  // Declare Enums such that they can be referenced in the HTML
  readonly IconTypeEnum = IconTypeEnum;

  constructor() 
  {
  }
  

  ngOnInit()   
  {
  }

  // When setting the size of an ion-img, we need to know the exact pixels
  convertSizeToPixels(): number
  {
    return this.convertStringToEnum(sizeConversionEnum, this.size);
  }

  // Method to retrieve an Enum from a provided string (case insensitive).
  // Will return null if no match is found.
  private convertStringToEnum<T>(enumObject: T, value: string) : T[keyof T] | null
  {
    if (!value)
    {
      return null;
    }
    
    let enumValue = Object.keys(enumObject).find(key => key.toString().toUpperCase() === value.toUpperCase());

    return enumValue ? enumObject[enumValue] : null;
  }
}